// extracted by mini-css-extract-plugin
module.exports = {"page":"Container__page--2_v1n","main":"Container__main--2iITN"};